---
fr:
  power_plant_responsible:
    delete_confirm_text: Êtes-vous sûr de vouloir retirer ce responsable de la centrale ? Cette action ne peut pas être annulée.
    delete_confirm_title: Retirer le responsable de la centrale
  responsible:
    add: Nouvelle personne responsable
    already_linked_description: Cette personne responsable est déjà liée à un compte utilisateur. Vous pouvez mettre à jour le nom et le téléphone, mais ne pouvez pas délier de l'utilisateur.
    already_linked_title: Déjà lié à un utilisateur
    auto_switched_description: Nous avons automatiquement basculé vers le mode "Lien avec utilisateur⋅trice" car cet e-mail correspond à un compte utilisateur existant.
    create_mode_description: Vous créez une nouvelle personne responsable. Remplissez le formulaire ci-dessous et enregistrez pour créer la nouvelle personne.
    create_mode_title: Créer une nouvelle personne responsable
    create_new: Ajouter un nouveau
    delete_confirm_text: Êtes-vous sûr de vouloir supprimer ce responsable ? Cette action ne peut pas être annulée.
    delete_confirm_title: Supprimer le responsable
    deleted_completely: "%{name} a été complètement supprimé du système."
    deleted_preserved: "%{name} a été retiré de cette entreprise mais conservé dans le système en raison d'autres connexions (notifications, tâches, etc.)."
    edit: Éditer personne responsable
    edit_mode_description: Vous éditez maintenant les détails de la personne responsable. Remplissez le formulaire ci-dessous et enregistrez pour mettre à jour les informations.
    edit_mode_title: Mode d'édition activé
    edit_plural: Éditer les responsables
    edit_power_plant_responsible: Éditer la personne responsable de la centrale
    edit_tooltip: Éditer ou créer une nouvelle personne responsable
    email_from_linked_user: E-mail du compte utilisateur lié
    email_match_detected_title: Correspondance d'e-mail détectée
    link_to_user: Lien avec utilisateur⋅trice
    linked_to_user: Lien avec utilisateur⋅trice
    matched_user: 'Utilisateur correspondant :'
    must_have_name_email: La personne responsable doit avoir un nom ou une adresse e-mail
    phone_change_warning_description: La modification de ce numéro de téléphone le mettra à jour pour le compte utilisateur lié partout dans le système.
    phone_change_warning_title: Avertissement de mise à jour du téléphone utilisateur
    phone_from_matched_user: Numéro de téléphone du compte utilisateur correspondant
    responsible: Responsable
    responsibles: Responsables
    role: Rôle
    save_and_link: Enregistrer et lier à l'utilisateur
    select_responsible: Sélectionner une personne responsable
    task_responsible: Accès à la gestion des tâches
